import tracePaymentTypes from "../actions/types/tracePayment.action.type";

export const tracePaymentInitialState = {
    error: null,
    tracePaymentData: null,
    tracePaymentDetails: null,
    initiateTraceData: null,
    initiateTraceDetails: null,
    count: 0,
    
};

export default function tracePaymentReducer(
    state = tracePaymentInitialState,
    action
) {
    switch (action.type) {
        case tracePaymentTypes.GET_TRACE_SUCCESS:
            return {
                tracePaymentData: action.data.data,
                error: null,
                tracePaymentDetails: action.data.tracePaymentDetails,
                count: action.data.count,
            };
        case tracePaymentTypes.GET_TRACE_ERROR:
            return {
                tracePaymentData: null,
                count: 0,
                error: action.error
            };
        case tracePaymentTypes.INITIATE_TRACE_SUCCESS:
            return {
                  ...state,
                  initiateTraceSuccessMessage: action.data,
                  initiateTraceDetails: null};
          
        case tracePaymentTypes.INITIATE_TRACE_ERROR:
                return {
                  ...state,
                  initiateTraceErrorMessage: action.error,
                  initiateTraceDetails: null};
        default:
            return state;
    }
}